{
  "places": {
    "z11-comparison-court": {
      "motes": 10,
      "mist": 0,
      "flames": [[246,645,0.65]],
      "moths": [[558,70]],
      "daylight": [{"from":[96,208],"to":[872,656],"width":[70,235],"colour":[208,222,235],"opacity":0.035,"exposure":0.5,"motes":12}]
    },
    "z12-white-joint": {"motes":0,"mist":0,"flames":[]}
  }
}
